import React from 'react';
import { FontIcon, mergeStyles } from '@fluentui/react';
import { tokens } from "@fluentui/react-components";
import { FONT_SIZE_LARGE, FONT_SIZE_L_REGULAR} from "../../../taskpane/config/fontSizes";
import LuggageTagText from '../LuggageTagText';
import useOfficeContext from '../../hooks/useOfficeContext';
import { pageHeaderAsideWidth } from '../../containers/OfficeContainer/mobileScale';

type Props = {
  headingText: string;
  icon: any;
};

const wrapperClasses = mergeStyles({
  padding: 10,
  display: 'flex',
 alignItems: 'center',
 gap: 2,
 maxWidth: '100%',
});

const asideClasses = (width: number) => mergeStyles({
  width,
  flexShrink: 0,
});

const bodyClasses = mergeStyles({
  fontSize: FONT_SIZE_L_REGULAR,
  color: tokens.colorNeutralForeground1,
  maxWidth: '90%', // Set a max width for truncation
});

const iconClass = mergeStyles({
  paddingTop: 5,
  fontSize:  FONT_SIZE_LARGE,
  color: tokens.colorNeutralForeground1,
});



const PageHeader: React.FC<Props> = ({ headingText, icon}) => {
  const { isMobile } = useOfficeContext();

  return (
    <div className={wrapperClasses}>
      <div className={asideClasses(pageHeaderAsideWidth(isMobile))}>
       <div className={iconClass}>{icon}</div>
      </div>
      <div className={bodyClasses}>
        <LuggageTagText text={headingText} />
      </div>
    </div>
  );
};

export default PageHeader;


